/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_DeletedInputs */

const en_byoa_deleted = /** @type {(inputs: Byoa_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI connection removed.`)
};

const id_byoa_deleted = /** @type {(inputs: Byoa_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koneksi AI dihapus.`)
};

/**
* | output |
* | --- |
* | "AI connection removed." |
*
* @param {Byoa_DeletedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_deleted = /** @type {((inputs?: Byoa_DeletedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_DeletedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_deleted(inputs)
	return en_byoa_deleted(inputs)
});